import {createSelector} from 'reselect'
import {cleanPhoneNumber} from 'services/formats'
import type {RootState} from 'services/store'

const requiredProfileFields = ['email', 'firstName', 'lastName'] as const
const requiredMarketingFields = ['email', 'phone'] as const

export const userRootSelector = (state: RootState) => state.user
export const userStatusSelector = createSelector([userRootSelector], user => user.status)
export const userSelector = createSelector([userRootSelector], user => user.data)

export const formattedUserSelector = createSelector([userSelector], user => {
  return {
    ...user,
    phone: cleanPhoneNumber(user.phone)
  }
})

export const userErrorSelector = createSelector([userRootSelector], user => user.error)
export const isUserProfileCompleteSelector = createSelector([userSelector], user =>
  requiredProfileFields.every(field => user[field])
)
export const isMarketingInfoCompleteSelector = createSelector([userSelector], user =>
  requiredMarketingFields.every(field => user[field])
)
